function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { InfaceEnv } from '@inface-sdk/common';
import { INPAY_ENV } from './env-variable.enum';
var envInfo = {
  version: process.env.__livestream_sdk_version || '__livestream_sdk_version',
  type: 'live',
  logLevel: 1 // WARN
};
function setEnvironmentVariable() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'live';
  var upperEnv = env.toUpperCase();
  Object.entries(INPAY_ENV).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      envName = _ref2[0],
      value = _ref2[1];
    // eslint-disable-next-line no-use-before-define
    delete inpayEnv[envName];
    if (value[upperEnv]) {
      // eslint-disable-next-line no-use-before-define
      inpayEnv[envName] = value[upperEnv];
    }
  });
}
var inpayEnv = {
  ENV_ENUM: Object.freeze({
    LOCAL: 'local',
    DEV: 'dev',
    TEST: 'test',
    TEST2: 'test2',
    PRE: 'pre',
    LIVE: 'live'
  }),
  LOG_LEVELS: Object.freeze({
    ERROR: 0,
    WARN: 1,
    INFO: 2,
    DEBUG: 3,
    VERVOSE: 3,
    FORCE: 9
  }),
  getSdkVersion: function getSdkVersion() {
    return "".concat(envInfo.version, "-").concat(envInfo.type);
  },
  getEnv: function getEnv() {
    return envInfo.type;
  },
  getMetaInfo: function getMetaInfo() {
    var obj = {
      logLevel: envInfo.logLevel
    };
    if (envInfo.type !== this.ENV_ENUM.LIVE) {
      obj.apis = {
        alltemAddress: this.ALLTEM_SERVER_ADDRESS,
        stampAddress: this.STAMP_SERVER_ADDRESS,
        dipayAddress: this.DIRECT_PAYMENT_API_ADDRESS
      };
    }
    return obj;
  },
  setEnv: function setEnv() {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : InfaceEnv.value.env || this.ENV_ENUM.LIVE;
    if (Object.keys(this.ENV_ENUM).some(function (env) {
      return env === val.toLocaleUpperCase();
    })) {
      envInfo.type = val.toLocaleLowerCase();
      setEnvironmentVariable(val);
    }
  },
  setLogLevel: function setLogLevel() {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.LOG_LEVELS.WARN;
    if (typeof val === 'number') {
      // eslint-disable-next-line no-bitwise
      if ((val === 9 || val <= 0 && val <= 3) && ~~val === val) {
        // eslint-disable-next-line no-bitwise
        envInfo.logLevel = ~~val;
      }
    } else if (typeof val === 'string' && Object.getOwnPropertyNames(this.LOG_LEVELS).includes(val.toUpperCase())) {
      envInfo.logLevel = this.LOG_LEVELS[val.toUpperCase()];
    }
  },
  canILog: function canILog(level) {
    if (typeof level !== 'number' || level < 0 || level > 3) {
      return false;
    }
    return level <= envInfo.logLevel;
  }
};
inpayEnv.setEnv();
inpayEnv.setLogLevel();
export default inpayEnv;